import "core-js/modules/es.number.to-fixed.js";
import { defineComponent as _defineComponent } from 'vue';
import moment from 'moment-timezone';
import DeleteIcon from '~/components/common/icons/Trash.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BMobileCartItem',
  props: {
    ticketData: {
      type: Object,
      default: function _default() {
        return {
          id: 0,
          name: '',
          price: 0,
          currency: '',
          discountName: '',
          seatId: '',
          occurrence: null,
          timeslot: null,
          occurrenceName: '',
          occurrenceStartAt: null,
          occurrenceEndAt: null,
          timeslotName: '',
          timeslotStartAt: null,
          timeslotEndAt: null
        };
      }
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  emits: ['remove'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useI18n = useI18n(),
      d = _useI18n.d;
    var formattedPrice = computed(function () {
      return props.ticketData.price.toFixed(2);
    });
    var isRecurringOrHasTimeslots = computed(function () {
      return props.ticketData.occurrenceName || props.ticketData.timeslotName;
    });
    var startDate = computed(function () {
      var eventStartDate;
      if (props.ticketData.timeslotStartAt) {
        eventStartDate = props.ticketData.timeslotStartAt;
      } else if (props.ticketData.occurrenceStartAt) {
        eventStartDate = props.ticketData.occurrenceStartAt;
      }
      var startDate = moment.parseZone(new Date(eventStartDate)).toDate();
      return {
        date: d(startDate, 'DD_MM_YYYY'),
        time: d(startDate, 'HH_mm')
      };
    });
    var endDate = computed(function () {
      var eventEndDate;
      if (props.ticketData.timeslotEndAt) {
        eventEndDate = props.ticketData.timeslotEndAt;
      } else if (props.ticketData.occurrenceEndAt) {
        eventEndDate = props.ticketData.occurrenceEndAt;
      }
      var endDate = moment.parseZone(new Date(eventEndDate)).toDate();
      return {
        date: d(endDate, 'DD_MM_YYYY'),
        time: d(endDate, 'HH_mm')
      };
    });
    var onSameDay = computed(function () {
      return startDate.value.date === endDate.value.date;
    });
    function deleteTicket() {
      emit('remove');
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      d: d,
      formattedPrice: formattedPrice,
      isRecurringOrHasTimeslots: isRecurringOrHasTimeslots,
      startDate: startDate,
      endDate: endDate,
      onSameDay: onSameDay,
      deleteTicket: deleteTicket,
      DeleteIcon: DeleteIcon
    };
  }
});